import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { defaultQueryOptions } from './common'
import { ClientLocationOrderValidationService } from '../services/client_location_order_validation.service'
import { OrderValidationResponseClientDto } from '../types/api'

export const useAdminPreRegValidation = (
  locationName: string,
  lupId: string
): UseQueryResult<OrderValidationResponseClientDto> => {
  return useQuery<OrderValidationResponseClientDto>({
    queryKey: ['useAdminPreRegValidation', locationName, lupId],
    queryFn: () => ClientLocationOrderValidationService.userValidation(locationName, lupId),
    ...defaultQueryOptions,
    enabled: !!lupId,
  })
}

export const useAdminPreRegValidationOrder = (
  locationName: string,
  lupId: string,
  orderId: string
): UseQueryResult<OrderValidationResponseClientDto> => {
  return useQuery<OrderValidationResponseClientDto>({
    queryKey: ['useAdminPreRegValidationOrder', locationName, lupId, orderId],
    queryFn: () => ClientLocationOrderValidationService.userOrderValidation(locationName, lupId, orderId),
    ...defaultQueryOptions,
  })
}
